import * as React from 'react';
import {
    Toolbar as RaToolbar,
    ToolbarProps,
    DeleteButton,
    SaveButton,
    usePermissions,
    useRecordContext,
    useResourceContext,
} from 'react-admin';

import { canAccess } from '../canAccess';

/**
 * Replacement for react-admin's Toolbar that adds RBAC control to actions
 *
 * Users must have the 'delete' permission on the resource and record to see the DeleteButton.
 */
export const Toolbar = (props: ToolbarProps) => {
    const { isLoading, permissions } = usePermissions();
    const resource = useResourceContext(props);
    const record = useRecordContext(props);
    if (isLoading) {
        return null;
    }

    return (
        <RaToolbar
            {...props}
            sx={{ display: 'flex', flex: 1, justifyContent: 'space-between' }}
        >
            <SaveButton />
            {record &&
                typeof record.id !== 'undefined' &&
                canAccess({
                    permissions,
                    action: 'delete',
                    resource,
                    record,
                }) && <DeleteButton />}
        </RaToolbar>
    );
};

Toolbar.propTypes = {
    ...RaToolbar.propTypes,
};
